export const parseFilterObj = (filters) => {
  if (!filters) return '';
  const params = new URLSearchParams();
  const keys = Object.keys(filters);
  keys.forEach((key) => {
    const value = filters[key];
    if (value !== '' && value !== null && value !== undefined) {
      params.set(key, String(value));
    }
  });
  const encoded = params.toString();
  return encoded ? `&${encoded}` : '';
};

export const parseUrlQuery = (url, query) => {
  const { pagination, searchValue, filters } = query;
  const { pageIndex, pageSize } = pagination;
  const searchQuery = searchValue ? `&query=${searchValue}` : '';

  return `${url}?page=${pageIndex + 1}&page_size=${pageSize}${searchQuery}${filters}`;
};
